module.exports = __webpack_public_path__ + "static/media/ilya-lix-4l5fsRjJqLM-unsplash.11bef94a.jpg";